import React from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';

/**
 * Public Layout - No sidebar, full-screen
 * Used for: /invite/:token, /login, landing page
 */
export const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100" data-testid="public-layout">
      {children || <Outlet />}
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default PublicLayout;
